/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramCategoryControllerFindOneByLinkQueryResponse,
  TelegramCategoryControllerFindOneByLinkPathParams,
  TelegramCategoryControllerFindOneByLink401,
  TelegramCategoryControllerFindOneByLink404,
} from '../types/TelegramCategoryControllerFindOneByLink.ts';

function getTelegramCategoryFindOneByLinkUrl(link: TelegramCategoryControllerFindOneByLinkPathParams['link']) {
  const res = { method: 'GET', url: `/api/telegram/category/link/${link}` as const };
  return res;
}

/**
 * {@link /api/telegram/category/link/:link}
 */
export async function telegramCategoryFindOneByLink(
  link: TelegramCategoryControllerFindOneByLinkPathParams['link'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramCategoryControllerFindOneByLinkQueryResponse,
    ResponseErrorConfig<TelegramCategoryControllerFindOneByLink401 | TelegramCategoryControllerFindOneByLink404>,
    unknown
  >({ method: 'GET', url: getTelegramCategoryFindOneByLinkUrl(link).url.toString(), ...requestConfig });
  return res.data;
}
